import { makeStyles } from "@material-ui/core";

export const useFormModalStyles = makeStyles(() => ({
  alert: {
    "margin-bottom": "20px",
  },
}));
